import axios from 'axios';
import './api_helper';
import { api } from '../config';

const BASE = api.API_URL;

export const getMarketingKpis = (empresaId, year) =>
    axios.get(`${BASE}/marketing/kpis`, { params: { empresa_id: empresaId, year } });

export const getMarketingLeadsMensuales = (empresaId, year) =>
    axios.get(`${BASE}/marketing/leads-mensuales`, { params: { empresa_id: empresaId, year } });

export const getMarketingPorFuente = (empresaId, year) =>
    axios.get(`${BASE}/marketing/por-fuente`, { params: { empresa_id: empresaId, year } });

export const getMarketingEmbudo = (empresaId, year) =>
    axios.get(`${BASE}/marketing/embudo`, { params: { empresa_id: empresaId, year } });

export const getMarketingCostePorLead = (empresaId, year) =>
    axios.get(`${BASE}/marketing/coste-por-lead`, { params: { empresa_id: empresaId, year } });

export const getMarketingParcial = (empresaId, filtroParcial) =>
    axios.get(`${BASE}/marketing/parcial`, {
        params: {
            empresa_id: empresaId,
            periodo: filtroParcial?.preset,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
        }
    });

// Search Console
const gscParams = (empresaId, periodo) => ({
    empresa_id: empresaId,
    date_from: periodo.from,
    date_to: periodo.to,
});

export const getGscSites = () =>
    axios.get(`${BASE}/marketing/search-console/sites`);

export const getGscKpis = (empresaId, periodo) =>
    axios.get(`${BASE}/marketing/search-console/kpis`, { params: gscParams(empresaId, periodo) });

export const getGscEvolucion = (empresaId, periodo) =>
    axios.get(`${BASE}/marketing/search-console/evolucion`, { params: gscParams(empresaId, periodo) });

export const getGscQueries = (empresaId, periodo) =>
    axios.get(`${BASE}/marketing/search-console/queries`, { params: gscParams(empresaId, periodo) });

export const getGscPages = (empresaId, periodo) =>
    axios.get(`${BASE}/marketing/search-console/pages`, { params: gscParams(empresaId, periodo) });
